module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAABJUlEQVRYR+3XuwrCMBQG4P+oD6EIZhJ8DQcXB90dKggBH8nLVsHdSZx8Dh2U1sE+RDFScJBabS6nItLO6cnXPyGnIfzIQz/iQAlJr8RLIuNFOFCk5gDqusvmS6GV7Gh2adcqty0IZ1+K3nP9lwLeMriaIJJiOpAHYg9CUwGHlRSdPIjSLa6b2DMCoDCuqu56Ik5fheggElDW0rAloosoFGKCKAxiiigEYoNgh9giWCEuCDaIK4IFwoFwhnAhnCC2CG8ZZB6YVierLSL5claItwiOILTfNbBPzZAbsgNBxFX00100ryOzQvIm+1oiJcQlgfS75R75i0SMrxMWeyjypWjk/MWHQ0DNTO82BpgIoKkvW5uPEIOCrEO1roqsM74pVkLSwdwB+34qMmDJNQIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/order/icon-update-active.png
// module id = +gWK
// module chunks = 4